import React from "react";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Card from "../../components/_upload_nft/Card/Card";
import styles from "./UploadNFT.module.scss";

const UploadNFT = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow} onClick={() => navigate("/")}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Upload new NFT</h1>

          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default UploadNFT;
